import {
	designTokens,
	Flex,
	Heading,
	InputCheckBox
} from "@itandi/itandi-bb-ui";
import type React from "react";
import { useCallback } from "react";
import type { DealType } from "~/models/Deal";
import type { DealDashboard } from "~/models/DealDashboard";

type Props = {
	dealDashboard: DealDashboard;
	dealTypes: DealType[];
	setDealTypes: React.Dispatch<React.SetStateAction<DealType[]>>;
};

/**
 * ダッシュボード画面用の案件状況選択コンポーネント
 *
 * @for client, vendor
 */

export const DealTypeFilter: React.FC<Props> = ({
	dealTypes,
	setDealTypes,
	dealDashboard
}: Props) => {
	const onChangeCheckbox = useCallback(
		(dealType: DealType): void => {
			if (dealDashboard === null) return;
			setDealTypes((prev) => {
				const index = prev.indexOf(dealType);
				return index === -1 ? [...prev, dealType] : prev.toSpliced(index, 1);
			});
		},
		[dealDashboard, setDealTypes]
	);
	const isRestorationChecked = dealTypes.includes("restoration");
	const isRepairChecked = dealTypes.includes("repair");
	const isOtherChecked = dealTypes.includes("other");
	const isSingleChecked = dealTypes.length === 1;
	return (
		<Flex alignItems="center" justifyContent="space-between">
			<Heading as="h2" mb={designTokens["spacing/m"]}>
				案件状況
			</Heading>
			<Flex gap={designTokens["spacing/m"]}>
				<InputCheckBox
					checked={isRestorationChecked}
					disabled={isSingleChecked ? isRestorationChecked : undefined}
					label="原状回復"
					onChange={(): void => {
						onChangeCheckbox("restoration");
					}}
				/>
				<InputCheckBox
					checked={isRepairChecked}
					disabled={isSingleChecked ? isRepairChecked : undefined}
					label="修繕"
					onChange={(): void => {
						onChangeCheckbox("repair");
					}}
				/>
				<InputCheckBox
					checked={isOtherChecked}
					disabled={isSingleChecked ? isOtherChecked : undefined}
					label="その他"
					onChange={(): void => {
						onChangeCheckbox("other");
					}}
				/>
			</Flex>
		</Flex>
	);
};
